import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/es'; 
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import FormControl from '@mui/material/FormControl';
import { useNavigate, useLocation } from 'react-router-dom';

dayjs.locale('es'); 

export default function CalendarioFiltro({ parametroURL, etiqueta }) {
    const navigate = useNavigate();
    const location = useLocation();

    const conseguirValorURL = () => {
        const params = new URLSearchParams(location.search);
        const fechaParam = params.get(parametroURL);
        return fechaParam ? dayjs(fechaParam, "DD-MM-YYYY") : null;
    };

    const [valorSeleccionado, setValorSeleccionado] = useState(null);

    useEffect(() => {
        setValorSeleccionado(conseguirValorURL());
    }, [location.search]);

    const handleChange = (newValue) => {
        const url = new URL(window.location);
        const params = new URLSearchParams(url.search);

        if (newValue === null) {
            params.delete(parametroURL);
        } else {
            const fechaFormateada = dayjs(newValue).format("DD-MM-YYYY");
            params.set(parametroURL, fechaFormateada);
        }

        navigate(`${url.pathname}?${params.toString()}`);
        setValorSeleccionado(newValue);
    };

    return (
        <FormControl sx={{ ml: 1, width: 160 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                <Stack spacing={3}>
                    <DesktopDatePicker
                        label={etiqueta}
                        inputFormat="DD/MM/YYYY"
                        value={valorSeleccionado}
                        onChange={handleChange}
                        renderInput={(params) => <TextField {...params} />}
                        clearable
                    />
                </Stack>
            </LocalizationProvider>
        </FormControl>
    );
}
